import { graphql } from "../gql";

export const deleteAskAutodorSavedPromptMutationDoc = graphql(`
  mutation deleteAskAutodorSavedPrompt(
    $input: AskAutodorDeleteSavedPromptInput!
  ) {
    askAutodorDeleteSavedPrompt(input: $input) {
      ...AskAutodorSavedPromptFragment
    }
  }
`);
